export default function ResourcesPage(){ return <div data-testid="resources-root" className="p-6">Resources</div>; }
